import React from 'react';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { InfoArea, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatRow } from '@screens/players/stat.display';
import { formatStringDate } from '@domain/utils/format.utils';

export const FreeSpinInfo = ({ info }: PlayerInfoProps) => {
  const freeSpin = info.detailFreeSpin;
  if (!freeSpin) return null;

  return (
    <InfoArea>
      <InfoAreaTitle>Free Spin</InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Last Free Spin'>{formatStringDate(freeSpin.timeBonusTrigger)}</StatRow>
        <StatRow label='Status'>{freeSpin.status}</StatRow>
      </StatsContainer>
    </InfoArea>
  );
};
